<template>
    <v-container>
        <div>
            <v-btn prepend-icon="mdi-arrow-left" @click="volver">
                {{ $t('volver') }}
            </v-btn>
        </div>

        <v-alert
            v-if="!$i18n.locale.startsWith('es')"
            type="info"
            class="mt-4">
            {{ $t('avisoIdiomaSoloEspañol') }}
        </v-alert>

        <div class="pb-12 pt-6 texto-legal">
            <h1>POLÍTICA DE COOKIES</h1>
            <h2>1. INFORMACIÓN SOBRE COOKIES</h2>

            <p>
                Conforme con la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico (LSSI), en relación con el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, General de Protección de Datos (GDPR) y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos y Garantía de los Derechos Digitales (LOPDGDD), es obligado obtener el consentimiento expreso del usuario de todas las páginas web que usan cookies prescindibles, antes de que este navegue por ellas.
            </p>

            <h2>2. ¿QUÉ SON LAS COOKIES?</h2>

            <p>Las cookies y otras tecnologías similares tales como local shared objects, flash cookies o píxeles, son herramientas empleadas por los servidores Web para almacenar y recuperar información acerca de sus visitantes, así como para ofrecer un correcto funcionamiento del sitio.</p>
            <p>Mediante el uso de estos dispositivos se permite al servidor Web recordar algunos datos concernientes al usuario, como sus preferencias para la visualización de las páginas de ese servidor, nombre y contraseña, productos que más le interesan, etc.</p>

            <h2>3. COOKIES AFECTADAS POR LA NORMATIVA Y COOKIES EXCEPTUADAS </h2>

            <p>Según la directiva de la UE, las cookies que requieren el consentimiento informado por parte del usuario son las cookies de analítica y las de publicidad y afiliación, quedando exceptuadas las de carácter técnico y las necesarias para el funcionamiento de la Web App o la prestación de servicios expresamente solicitados por el usuario.</p>

            <h2>4. TIPOS DE COOKIES</h2>

            <h3>SEGÚN LA FINALIDAD</h3>
            <ul>
                <li>Cookies técnicas y funcionales: son aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan.</li>
                <li>Cookies analíticas: son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma y para la elaboración de perfiles de navegación de los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</li>
                <li>Cookies publicitarias: son aquellas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.</li>
                <li>Cookies de publicidad comportamental: recogen información sobre las preferencias y elecciones personales del usuario (retargeting) para permitir la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado.</li>
                <li>Cookies sociales: son establecidas por las plataformas de redes sociales en los servicios para permitirle compartir contenido con sus amigos y redes. Las plataformas de medios sociales tienen la capacidad de rastrear su actividad en línea fuera de los Servicios. Esto puede afectar al contenido y los mensajes que ve en otros servicios que visita. </li>
                <li>Cookies de afiliados: permiten hacer un seguimiento de las visitas procedentes de otras webs, con las que el el sitio web establece un contrato de afiliación (empresas de afiliación).</li>
                <li>Cookies de seguridad: almacenan información cifrada para evitar que los datos guardados en ellas sean vulnerables a ataques maliciosos de terceros.</li>
            </ul>
            <h3>SEGÚN LA PROPIEDAD</h3>
            <ul>
                <li>Cookies propias: son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario.</li>
                <li>Cookies de terceros: son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el editor, sino por otra entidad que trata los datos obtenidos través de las cookies.</li>
            </ul>
            <h3>SEGÚN EL PLAZO DE CONSERVACIÓN</h3>
            <ul>
                <li>Cookies de sesión: son un tipo de cookies diseñadas para recabar y almacenar datos mientras el usuario accede a una página web.</li>
                <li>Cookies persistentes: son un tipo de cookies en el que los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un período definido por el responsable de la cookie, y que puede ir de unos minutos a varios años.</li>
            </ul>

            <h2>4. TRATAMIENTO DE DATOS PERSONALES</h2>

            <p>{{ farmacia.rgpddenominacionsocial }} es el <b>Responsable del tratamiento</b> de los datos personales del Interesado y le informa de que estos datos serán tratados de conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril de 2016 (GDPR), por lo que se le facilita la siguiente información del tratamiento:</p>
            <p><b>Fines del tratamiento: </b>según se especifica en el apartado de cookies que se utilizan en esta Web App.</p>
            <p><b>Legitimación del tratamiento:</b> salvo en los casos en los que resulte necesario para la navegación por la web, por consentimiento del interesado (art. 6.1 GDPR).</p>
            <p><b>Criterios de conservación de los datos:</b> según se especifica en el apartado de cookies utilizadas en la web.</p>
            <p><b>Comunicación de los datos:</b> no se comunicarán los datos a terceros, excepto en cookies propiedad de terceros o por obligación legal.</p>
            <div>
                <b>Derechos que asisten al Interesado:</b>
                <ul>
                    <li>Derecho a retirar el consentimiento en cualquier momento.</li>
                    <li>Derecho de acceso, rectificación, portabilidad y supresión de sus datos, y de limitación u oposición a su tratamiento.</li>
                    <li>Derecho a presentar una reclamación ante la Autoridad de control (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa vigente.</li>
                </ul>
            </div>
            <p><b ref="posicion">Datos de contacto para ejercer sus derechos:</b> {{ farmacia.rgpddenominacionsocial }} - {{ farmacia.rgpddomiciliosocial }} - E-mail: {{ farmacia.rgpdemail }}</p>

            <h2 id="configuracion" class="pt-6">
                5. COOKIES UTILIZADAS EN ESTE SITIO WEB
            </h2>

            <cookies-panel />

            <h2 class="mt-8 mb-4">
                CÓMO GESTIONAR LAS COOKIES
            </h2>

            <v-card>
                <v-table>
                    <tbody>
                        <tr>
                            <td class="text-left pa-4">
                                <b>Eliminar las cookies del dispositivo</b>
                            </td>
                            <td class="text-left pa-4">
                                Las cookies que ya están en un dispositivo se pueden eliminar borrando el historial del navegador, con lo que se suprimen las cookies de todos los sitios web visitados.
                                Sin embargo, también se puede perder parte de la información guardada (por ejemplo, los datos de inicio de sesión o las preferencias de sitio web).
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left pa-4">
                                <b>Gestionar las cookies específicas del sitio</b>
                            </td>
                            <td class="text-left pa-4">
                                Para tener un control más preciso de las cookies específicas de cada sitio, los usuarios pueden ajustar su configuración de privacidad y cookies en el navegador.
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left pa-4">
                                <b>Bloquear las cookies</b>
                            </td>
                            <td class="text-left pa-4">
                                Aunque la mayoría de los navegadores modernos se pueden configurar para evitar que se instalen cookies en los dispositivos, eso puede obligar al ajuste manual de determinadas preferencias cada vez que se visite un sitio o página. Además, algunos servicios y características pueden no funcionar correctamente (por ejemplo, los inicios de sesión con perfil).
                            </td>
                        </tr>
                    </tbody>
                </v-table>
            </v-card>

            <h2 class="mt-8 mb-4">
                CÓMO ELIMINAR LAS COOKIES DE LOS NAVEGADORES MÁS COMUNES
            </h2>
            <v-card>
                <v-table>
                    <tbody>
                        <tr>
                            <td class="text-left pa-4">
                                <b>Chrome</b>
                            </td>
                            <td class="text-left pa-4">
                                <a href="http://support.google.com/chrome/answer/95647?hl=es">http://support.google.com/chrome/answer/95647?hl=es</a>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left pa-4">
                                <b>Edge</b>
                            </td>
                            <td class="text-left pa-4">
                                <a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09">https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09</a>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left pa-4">
                                <b>Explorer</b>
                            </td>
                            <td class="text-left pa-4">
                                <a href="https://support.microsoft.com/es-es/help/278835/how-to-delete-cookie-files-in-internet-explorer">https://support.microsoft.com/es-es/help/278835/how-to-delete-cookie-files-in-internet-explorer</a>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left pa-4">
                                <b>Firefox</b>
                            </td>
                            <td class="text-left pa-4">
                                <a href="https://www.mozilla.org/es-ES/privacy/websites/#cookies">https://www.mozilla.org/es-ES/privacy/websites/#cookies</a>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left pa-4">
                                <b>Safari</b>
                            </td>
                            <td class="text-left pa-4">
                                <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac">https://support.apple.com/es-es/guide/safari/sfri11471/mac</a>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left pa-4">
                                <b>Opera</b>
                            </td>
                            <td class="text-left pa-4">
                                <a href="https://help.opera.com/en/latest/security-and-privacy/#clearBrowsingData">https://help.opera.com/en/latest/security-and-privacy/#clearBrowsingData</a>
                            </td>
                        </tr>
                    </tbody>
                </v-table>
            </v-card>
        </div>
    </v-container>
</template>
<script>
import { store } from '@/store';
import CookiesPanel from '../../components/CookiesPanel.vue';

export default {
    components: {
        CookiesPanel,
    },
    computed: {
        farmacia() {
            return store.farmacia;
        },
    },
    mounted() {
        if (this.$route.params.configuracion === 'true') {
            setTimeout(() => {
                this.$refs['posicion'].scrollIntoView({ behavior: 'auto'});
            }, 200);

        }
    },
    methods: {
        volver() {
            this.$router.back();
        },
    },
};
</script>

<style scoped>

</style>
